import React, {
  forwardRef,
  useRef,
  useContext,
  useEffect,
  // useState,
  useImperativeHandle,
  // useMemo,
} from 'react';
import BasicSettingsStyled from './BasicSettingsStyled';
import {
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Checkbox,
  FormHelperText,
  useTheme,
  InputAdornment,
  Button,
  // Autocomplete,
} from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import DateRangePickerML from '@/components/DateRangePickerML';
import dayjs from 'dayjs';
import { Context } from '../../AddMarketing';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import ClearIconML from '@/components/ClearIconML/index';
import { useIntl } from 'umi';

// eslint-disable-next-line no-unused-vars
export default forwardRef((props, fref) => {
  const {
    marketingId,
    setTitle,
    isBirthday,
    setIsBirthday,
    title,
    type,
    id,
    dateType,
    dateBeginTimestamp,
    dateEndTimestamp,
    dateCycleBeginDay,
    dateCycleEndDay,
    dateFixDay,
    dateFixMonth,
    setDateType,
    setDateCycleBeginDay,
    setDateCycleEndDay,
    setDateFixDay,
    setDateFixMonth,
    setDateBeginTimestamp,
    setDateEndTimestamp,
    opt,
    handleSubmitSuccess,
    // control,
  } = props || {};
  const intl = useIntl();
  const { formatMessage } = intl;

  const theme = useTheme();
  const { handleSubmit, errors, setValue, control, getValues } = useForm();
  // const [fixDay, setFixDay] = useState();

  const day = Array.from(new Array(29).keys()).slice(1);
  const month = Array.from(new Array(13).keys()).slice(1);

  useEffect(() => {
    if (id) {
      setValue('title', title);
      setValue('dateFixDay', dateFixDay);
      setValue('dateCycleBeginDay', dateCycleBeginDay);
      setValue('dateCycleEndDay', dateCycleEndDay);
      setValue('dateFixMonth', dateFixMonth);
      // setFixDay(dateFixDay);
      setValue('dateBeginTimestamp', dateBeginTimestamp);
      setValue('dateEndTimestamp', dateEndTimestamp);
      setValue('date', {
        startDate: dateBeginTimestamp,
        endDate: dateEndTimestamp,
      });
    }
  }, [
    dateBeginTimestamp,
    dateEndTimestamp,
    dateFixDay,
    id,
    setValue,
    title,
    dateCycleBeginDay,
    dateCycleEndDay,
    dateFixMonth,
  ]);

  const { ref } = useContext(Context);
  const submitRef = useRef();

  const clickInput = () => {
    submitRef.current.click();
  };

  useImperativeHandle(ref, () => ({
    // handleSubmit 就是暴露给父组件的方法
    clickInput: clickInput,
  }));

  // 清除日期
  const handleClearDay = () => {
    setDateFixDay();
  };

  const handleClearBeginDay = () => {
    setDateCycleBeginDay();
  };

  const handleClearEndDay = () => {
    setDateCycleEndDay();
  };

  const handleClearDateFixMonth = () => {
    setDateFixMonth();
  };

  const handleClearDateFixDay = () => {
    setDateFixDay();
  };

  // 生日营销
  const actionCycle = () => {
    return (
      <div className="birth-wrap">
        <FormControl disabled={opt === 'detail'}>
          <FormLabel component="legend" className="basic-cycle">
            <span className="label-require">*</span>
            {/* 活动周期 */}
            {formatMessage({ id: 'marketing.scene.birth.n01.lbl03' })}
          </FormLabel>
          <Controller
            render={(pr) => (
              <RadioGroup
                aria-label="date"
                name="customized-radios"
                className="cycle-select-wrap checkbox-radio-disabled-color"
                onChange={(e) => {
                  setDateType(e.target.value);
                  // setDateFixDay(e.target.value);
                  return pr.onChange(e.target.value);
                }}
                value={dateType}
              >
                <FormControlLabel
                  value="BIRTHDAY_DAY"
                  control={
                    <Radio color="primary" disabled={opt === 'detail'} />
                  }
                  color="primary"
                  // label="生日当天发放"
                  label={formatMessage({
                    id: 'marketing.scene.birth.n01.rdo04',
                  })}
                />
                <div style={{ color: opt === 'detail' ? 'darkgray' : '' }}>
                  {/* 只有选择了生日当月的才进行校验 */}
                  <FormControlLabel
                    value="BIRTHDAY_MONTH"
                    control={
                      <Radio color="primary" disabled={opt === 'detail'} />
                    }
                    // label="生日当月"
                    label={formatMessage({
                      id: 'marketing.scene.birth.n01.rdo05',
                    })}
                  />
                  <FormControl
                    variant="standard"
                    className="date single-select date-month"
                    disabled={opt === 'detail'}
                  >
                    <Controller
                      render={(rpr) => (
                        <Select
                          disabled={
                            opt === 'detail' || dateType === 'BIRTHDAY_DAY'
                          }
                          onChange={(e) => {
                            setDateFixDay(e.target.value);
                            return rpr.onChange(e.target.value);
                          }}
                          value={
                            dateType === 'BIRTHDAY_MONTH'
                              ? dateFixDay
                              : rpr.value
                          }
                        >
                          {day &&
                            day.map((item) => (
                              <MenuItem key={item.id} value={item} name={item}>
                                {/*  日 */}
                                {item + '日'}
                                {/* {item + formatMessage({ id: 'comm.date.lbl.03' })} */}
                              </MenuItem>
                            ))}
                        </Select>
                      )}
                      label=""
                      name="dateFixDay"
                      defaultValue=""
                      control={control}
                      rules={{
                        required: dateType === 'BIRTHDAY_MONTH',
                      }}
                      disabled={opt === 'detail'}
                      // {...register('dateFixDay', { required: true })}
                    />
                    {opt !== 'detail' && (
                      <ClearIconML
                        disabled={opt === 'detail'}
                        bottom={'10'}
                        right={'8'}
                        handleClick={handleClearDay}
                        clearValue={dateType === 'BIRTHDAY_MONTH' && dateFixDay}
                      ></ClearIconML>
                    )}
                  </FormControl>
                  {/* 发放 */}
                  {formatMessage({ id: 'marketing.scene.birth.n01.rdo06' })}
                </div>
              </RadioGroup>
            )}
            control={control}
            name="couponUsingThreshold"
          />
          <FormHelperText
            error={Boolean(errors.dateFixDay)}
            className="error-wrap"
            sx={{ fontSize: '12px' }}
          >
            {/* {errors.dateFixDay?.type === 'required' &&
              dateType === 'BIRTHDAY_MONTH' &&
              '请选择日期'} */}
            {Boolean(errors.dateFixDay) &&
              dateType === 'BIRTHDAY_MONTH' &&
              // '请选择时间'
              formatMessage({ id: 'marketing.scene.c01.txt02' })}
          </FormHelperText>
          <div className="basic-cycle-label checkbox-radio-disabled-color">
            <FormControlLabel
              // disabled={detail}
              control={
                <Checkbox
                  checked={isBirthday}
                  onChange={(e) => {
                    setIsBirthday(e.target.checked);
                  }}
                  name="isBirthday"
                  color="primary"
                  control={control}
                  // disabled={detail}
                />
              }
              label={formatMessage({ id: 'marketing.scene.birth.n01.chb06' })}
              // label="注册当月为生日月，则当月不发放"
            />
          </div>
        </FormControl>
      </div>
    );
  };

  // 会员日
  const actionMembers = () => {
    return (
      <div>
        <FormLabel component="legend" className="basic-cycle">
          <span className="label-require">*</span>
          {/* 活动周期 */}
          {formatMessage({ id: 'marketing.scene.birth.n01.lbl03' })}
        </FormLabel>
        <Controller
          render={(rp) => (
            <RadioGroup
              className="basic-cycle-group checkbox-radio-disabled-color"
              aria-label="couponUsingThresholdState"
              onChange={(e) => {
                setDateType(e.target.value);
                return rp.onChange(e.target.value);
              }}
              value={dateType}
              disabled={opt === 'detail'}
            >
              <div className="basic-cycle-group-wrap">
                <FormControlLabel
                  value={'CYCLE_MONTH'}
                  control={<Radio disabled={opt === 'detail'} />}
                  label=""
                />
                {/* 每月 */}
                {formatMessage({ id: 'marketing.people.regnotcon.n03.rdo10' })}
                <FormControl
                  variant="standard"
                  className="date single-select"
                  disabled={opt === 'detail'}
                >
                  <Controller
                    render={(pr) => (
                      <Select
                        onChange={(e) => {
                          setDateCycleBeginDay(e.target.value);
                          return pr.onChange(e.target.value);
                        }}
                        value={dateType === 'CYCLE_MONTH' ? pr.value : ''}
                      >
                        {day &&
                          day.map((item) => (
                            <MenuItem key={item.id} value={item} name={item}>
                              {item + '日'}
                            </MenuItem>
                          ))}
                      </Select>
                    )}
                    label={formatMessage({ id: 'marketing.scene.n09.rdo02' })}
                    // label="类型"
                    name="dateCycleBeginDay"
                    defaultValue=""
                    control={control}
                    rules={{
                      required: dateType === 'CYCLE_MONTH',
                    }}
                    disabled={opt === 'detail'}
                  />
                  {opt !== 'detail' && (
                    <ClearIconML
                      disabled={opt === 'detail'}
                      bottom={'12'}
                      right={'15'}
                      handleClick={handleClearBeginDay}
                      clearValue={
                        dateType === 'CYCLE_MONTH' && dateCycleBeginDay
                      }
                    ></ClearIconML>
                  )}
                </FormControl>
                {/* 至 */}
                {formatMessage({ id: 'marketing.scene.holiday.n01.lbl05' })}
                <FormControl
                  variant="standard"
                  className="date single-select"
                  disabled={opt === 'detail'}
                >
                  <Controller
                    render={(pr) => (
                      <Select
                        onChange={(e) => {
                          // console.log(e.target.value);
                          setDateCycleEndDay(e.target.value);
                          // setCouponGetStartTypeState(e.target.value);
                          return pr.onChange(e.target.value);
                        }}
                        value={dateType === 'CYCLE_MONTH' ? pr.value : ''}
                      >
                        {day &&
                          day.map((item) => (
                            <MenuItem key={item.id} value={item} name={item}>
                              {item + '日'}
                            </MenuItem>
                          ))}
                      </Select>
                    )}
                    label=""
                    name="dateCycleEndDay"
                    defaultValue=""
                    control={control}
                    rules={{
                      required: dateType === 'CYCLE_MONTH',
                    }}
                    disabled={opt === 'detail'}
                  />
                  {opt !== 'detail' && (
                    <ClearIconML
                      disabled={opt === 'detail'}
                      bottom={'12'}
                      right={'15'}
                      handleClick={handleClearEndDay}
                      clearValue={dateType === 'CYCLE_MONTH' && dateCycleEndDay}
                    ></ClearIconML>
                  )}
                </FormControl>
              </div>
              <div>
                <FormHelperText
                  error={Boolean(errors.dateCycleEndDay)}
                  className="error-wrap"
                  sx={{ fontSize: '12px' }}
                >
                  {Boolean(errors.dateCycleBeginDay) &&
                    dateType === 'CYCLE_MONTH' &&
                    // '请选择开始日期'
                    formatMessage({ id: 'marketing.scene.c01.txt05' })}
                </FormHelperText>
                <FormHelperText
                  error={Boolean(errors.dateCycleBeginDay)}
                  className="error-wrap"
                  sx={{ fontSize: '12px' }}
                >
                  {Boolean(errors.dateCycleEndDay) &&
                    dateType === 'CYCLE_MONTH' &&
                    // '请选择结束日期'
                    formatMessage({ id: 'marketing.scene.c01.txt06' })}
                </FormHelperText>
                <FormHelperText
                  error={Boolean(errors.dateType)}
                  className="error-wrap"
                  sx={{ fontSize: '12px' }}
                >
                  {Boolean(errors.dateType) &&
                    dateType === 'CYCLE_MONTH' &&
                    // '开始日期不得大于结束日期'
                    formatMessage({ id: 'marketing.scene.c01.txt07' })}
                </FormHelperText>
              </div>
              <div className="basic-cycle-group-wrap">
                <FormControlLabel
                  value={'FIXED_DAY'}
                  control={<Radio disabled={opt === 'detail'} />}
                  label=""
                />
                {/* 每年 */}
                {formatMessage({ id: 'marketing.scene.memberday.n01.rdo04' })}
                <FormControl
                  variant="standard"
                  className="date single-select"
                  disabled={opt === 'detail'}
                >
                  <Controller
                    render={(pr) => (
                      <Select
                        onChange={(e) => {
                          // console.log(e.target.value);
                          setDateFixMonth(e.target.value);
                          // setCouponGetStartTypeState(e.target.value);
                          return pr.onChange(e.target.value);
                        }}
                        value={dateType === 'FIXED_DAY' ? pr.value : ''}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {/* 月 */}
                              {formatMessage({ id: 'comm.date.lbl.05' })}
                            </InputAdornment>
                          ),
                        }}
                      >
                        {month &&
                          month.map((item) => (
                            <MenuItem key={item.id} value={item} name={item}>
                              {item}
                            </MenuItem>
                          ))}
                      </Select>
                    )}
                    label=""
                    name="dateFixMonth"
                    defaultValue=""
                    control={control}
                    rules={{
                      required: dateType === 'FIXED_DAY',
                    }}
                    disabled={opt === 'detail'}
                  />
                  {opt !== 'detail' && (
                    <ClearIconML
                      disabled={opt === 'detail'}
                      bottom={'10'}
                      right={'15'}
                      handleClick={handleClearDateFixMonth}
                      clearValue={dateType === 'FIXED_DAY' && dateFixMonth}
                    ></ClearIconML>
                  )}
                </FormControl>
                {/* 月 */}
                {formatMessage({ id: 'comm.date.lbl.05' })}
                <FormControl
                  variant="standard"
                  className="date single-select"
                  disabled={opt === 'detail'}
                >
                  <Controller
                    render={(pr) => (
                      <Select
                        onChange={(e) => {
                          // console.log(e.target.value);
                          setDateFixDay(e.target.value);
                          return pr.onChange(e.target.value);
                        }}
                        value={dateType === 'FIXED_DAY' ? pr.value : ''}
                      >
                        {day &&
                          day.map((item) => (
                            <MenuItem key={item.id} value={item} name={item}>
                              {item}
                            </MenuItem>
                          ))}
                      </Select>
                    )}
                    label=""
                    name="dateFixDay"
                    defaultValue=""
                    control={control}
                    rules={{
                      required: dateType === 'FIXED_DAY',
                    }}
                    disabled={opt === 'detail'}
                  />
                  {opt !== 'detail' && (
                    <ClearIconML
                      disabled={opt === 'detail'}
                      bottom={'10'}
                      right={'15'}
                      handleClick={handleClearDateFixDay}
                      clearValue={dateType === 'FIXED_DAY' && dateFixDay}
                    ></ClearIconML>
                  )}
                </FormControl>
                {/* 日 */}
                {formatMessage({ id: 'comm.date.lbl.03' })}
              </div>
            </RadioGroup>
          )}
          rules={{
            validate: () => {
              if (dateCycleBeginDay > dateCycleEndDay) {
                return false;
              }
            },
          }}
          control={control}
          name="dateType"
        />

        <FormHelperText
          error={Boolean(errors.dateFixMonth)}
          className="error-wrap"
          sx={{ fontSize: '12px' }}
        >
          {Boolean(errors.dateFixMonth) &&
            dateType === 'FIXED_DAY' &&
            // '请选择月份'
            formatMessage({ id: 'marketing.scene.c01.txt03' })}
        </FormHelperText>
        <FormHelperText
          error={Boolean(errors.dateFixDay)}
          className="error-wrap"
          sx={{ fontSize: '12px' }}
        >
          {Boolean(errors.dateFixDay) &&
            dateType === 'FIXED_DAY' &&
            // '请选择日期'
            formatMessage({ id: 'marketing.scene.c01.txt04' })}
        </FormHelperText>
      </div>
    );
  };

  // 节日营销
  const actionTimes = () => {
    return (
      <div>
        <FormLabel component="legend" className="basic-cycle">
          <span className="label-require">*</span>
          {formatMessage({ id: 'marketing.scene.holiday.n01.lbl03' })}
        </FormLabel>
        <FormControl
          variant="standard"
          className="date-wrap"
          disabled={opt === 'detail'}
          autoComplete="off"
        >
          <Controller
            render={(rp) => (
              <DateRangePickerML
                label="日期"
                title=""
                startText={formatMessage({
                  id: 'marketing.scene.holiday.n01.rdo04',
                })}
                endText={formatMessage({
                  id: 'marketing.scene.holiday.n01.rdo06',
                })}
                defaultStartDate={dateBeginTimestamp}
                defaultEndDate={dateEndTimestamp}
                rp={rp}
                name="custom-form-submit-name"
                onChange={(e) => {
                  setValue('date', {
                    startDate: dayjs(e.startDate).format('YYYY-MM-DD HH:mm:ss'),
                    endDate: dayjs(e.endDate).format('YYYY-MM-DD HH:mm:ss'),
                  });
                  setDateBeginTimestamp(
                    dayjs(e.startDate).format('YYYY-MM-DD HH:mm:ss'),
                  );
                  setDateEndTimestamp(
                    dayjs(e.endDate).format('YYYY-MM-DD 23:59:59'),
                  );
                }}
                disabled={opt === 'detail'}
                // isReset={opt === 'detail'}
              />
            )}
            name="date"
            control={control}
            rules={{
              validate: () => {
                if (
                  getValues('date')?.startDate &&
                  getValues('date')?.endDate
                ) {
                  return true;
                }
                return false;
              },
            }}
          />
        </FormControl>
        <FormHelperText
          error={Boolean(errors.date)}
          className="error-wrap"
          sx={{ fontSize: '12px' }}
        >
          {Boolean(errors.date) &&
            formatMessage({ id: 'marketing.scene.c01.txt02' })}
        </FormHelperText>
      </div>
    );
  };

  const editType = (type1) => {
    const showAction = new Map([
      ['BIRTHDAY_ACTIVITY', actionCycle()],
      ['MEMBER_ACTIVITY', actionMembers()],
      ['FESTIVAL_ACTIVITY', actionTimes()],
    ]);
    return showAction.get(type1);
  };

  const showActionList = (eid) => {
    const showList = new Map([
      ['1', actionCycle()],
      ['2', actionMembers()],
      ['3', actionTimes()],
    ]);
    return showList.get(eid);
  };

  const labelML = (
    <>
      <span className="label-require">*</span>
      <span className="label-name">
        {formatMessage({ id: 'marketing.scene.holiday.n01.lbl02' })}
      </span>
    </>
  );

  return (
    <BasicSettingsStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <div className="basic-title">
          {formatMessage({ id: 'marketing.scene.holiday.n01.lbl01' })}
        </div>
        <Controller
          render={(pr) => (
            <TextField
              variant="standard"
              id="outlined-multiline-static"
              autoComplete="off"
              label={labelML}
              value={pr.value || title || ''}
              placeholder=""
              className="basic-name"
              onChange={(e) => {
                setTitle(e.target.value);
                return pr.onChange(e.target.value);
              }}
              error={Boolean(errors.title)}
              helperText={
                errors.title ? (
                  <span style={{ fontSize: '12px' }}>
                    {formatMessage({ id: 'marketing.scene.c01.txt01' })}
                  </span>
                ) : (
                  ''
                )
              }
              disabled={opt === 'detail'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {
                        setTitle('');
                        setValue('title', '');
                      }}
                      edge="end"
                      disabled={opt === 'detail'}
                    >
                      {title && <ClearIcon className="clear-icon" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
          control={control}
          name="title"
          rules={{
            required: true,
            validate: () => {
              if (
                !title ||
                title.trim() === 'null' ||
                title.trim() === '' ||
                title.trim() === undefined
              ) {
                return false;
              }
            },
          }}
        />
        {marketingId && !type && showActionList(marketingId.toString())}
        {type && editType(type)}
        <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
      </form>
    </BasicSettingsStyled>
  );
});
